<div class="client-container">
  <div class="title-client-catalog">
    <span>Client Catalog</span>
  </div>
  <div class="search">

  </div>
  <div class="buttons">
    <button type="button" (click)="NuevoCliente()">New Client</button>
    <input type="text" placeholder="Search" (input)="onSearchChange($event.target.value)">
  </div>
  <table>
    <caption></caption>
    <thead>
      <tr class="title-table">
        <th scope="col">Id</th>
        <th scope="col">Code</th>
        <th scope="col">Name</th>
        <th scope="col">Parent</th>
        <th scope="col">Type</th>
        <th scope="col">Gov Number</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let client of clientListFilterShow | paginate: { itemsPerPage: sizePagination, currentPage: page }">
        <td>{{client.id}}</td>
        <td>{{client.code}}</td>
        <td>{{client.name}}</td>
        <td>{{client.parentIdName}}</td>
        <td>{{client.clientTypeName}}</td>
        <td>{{client.govNumber}}</td>
        <td>
          <button type="button" (click)="EditClient(client)">Edit</button>
          <button type="button" (click)="DeleteClient(client)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="pagination-container">
    <pagination-controls (pageChange)="page = $event" responsive="true" previousLabel="" nextLabel=""
      screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page" screenReaderCurrentLabel="You're on page">
    </pagination-controls>
  </div>
</div>

<div #clientNewEdit class="modal">
  <div class="container-close">
    <span (click)="CloseModal()" class="close">&times;</span>
  </div>
  <div class="container-center">
    <div class="form-client">
      <neoris-client-new-update (refreshEvent)="LoadData()" (closeEvent)="CloseModal()" [clientList]="clientList"
        [clientTypesList]="clientTypesList" [condition]="condition" [clientEdit]="clientEdit">
      </neoris-client-new-update>
    </div>
  </div>
</div>

<div #clientDelete class="modal">
  <div class="container-close">
    <span (click)="CloseModalDelete()" class="close">&times;</span>
  </div>
  <div class="questions-delete">
    <span>
      Do you really want to delete?
    </span>
    <div class="buttons-delete">
      <button (click)="DeleteClientDto()">Yes</button>
      <button (click)="CloseModalDelete()">No</button>
    </div>
  </div>
</div>
